// extracted by mini-css-extract-plugin
export default {"link":"_AppLink_link__AfRVB","span":"_AppLink_span__QlfUj"};